import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {MatPaginator} from '@angular/material/paginator';
import {ManagerService} from '../manager/manager.service';
import {Vacation} from '../admin/models/vacation.model';

@Component({
    selector: 'app-decline-pop-up',
    templateUrl: './decline-pop-up.component.html',
    styleUrls: ['./decline-pop-up.component.scss']
})
export class DeclinePopUpComponent implements OnInit {

    public vacation = {} as Vacation;
    public isPageLoading = false;

    @ViewChild(MatPaginator) paginator: MatPaginator | undefined;

    constructor(public dialogRef: MatDialogRef<[]>,
                private readonly fabMessageService: FabMessageService,
                private readonly managerService: ManagerService,
                @Inject(MAT_DIALOG_DATA) public selectedData: any) {
    }

    ngOnInit(): void {
        this.vacation = this.selectedData.value;
    }

    close(): void {
        this.dialogRef.close();
    }

    public decline(data: any) {
        data.requestStatus = 'DECLINED';
        data.managerComment = this.selectedData.value.managerComment;
        this.isPageLoading = true;
        if (this.selectedData.tag == 'workabroad') {
            if (data.vacations) {
                data.vacations.forEach((request: any) => {
                    if (request.requestStatus === 'PENDING') {
                        request.requestStatus = 'DECLINED';
                        request.managerComment = this.selectedData.value.managerComment;
                        this.managerService.declineVacationRequest(request).subscribe({
                            next: () => {
                                this.fabMessageService.displayMessage('success');
                                this.isPageLoading = false;
                            }, error: (err: HttpErrorResponse) => {
                                this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                                this.isPageLoading = false;
                            }
                        });
                    }
                })
            }
            this.managerService.declineWorkRequest(data).subscribe({
                next: () => {
                    this.fabMessageService.displayMessage('success');
                    this.isPageLoading = false;
                    this.close();
                }, error: (err: HttpErrorResponse) => {
                    this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                    this.isPageLoading = false;
                }
            });
        } else {
            this.managerService.declineVacationRequest(data).subscribe({
                next: () => {
                    this.fabMessageService.displayMessage('success');
                    this.isPageLoading = false;
                    this.close();
                }, error: (err: HttpErrorResponse) => {
                    this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                    this.isPageLoading = false;
                }
            });
        }
    }

}
